export default {
  manage_driverStatus: "Estados de Conductor",
  manage_driverStatusTable_driverStatusName: "Nombre",
  manage_driverStatusTable_accumulateTime: "Acumulación de Tiempo",
  manageDriverStatus_clockIn: "Marcar entrada",
  manageDriverStatus_clockOut: "Marcar salida",
  manageDriverStatus_mealBreakBegin: "Inicio descanso",
  manageDriverStatus_mealBreakEnd: "Fin descanso",
  manage_driverStatus_search_by_name: "Buscar por Nombre",
};
